module.exports = __webpack_public_path__ + "static/index/img/baikal-503.0ca8c399.jpg";